import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { UserPublic, LoginResponse } from '../types/api'
import { apiFetch } from '../lib/api'

interface AuthState {
  user: UserPublic | null
  token: string | null
  hydrated: boolean
  login: (credentials: { email: string; password: string }) => Promise<LoginResponse>
  logout: () => void
  refreshMe: () => Promise<void>
  setHydrated: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      hydrated: false,
      async login({ email, password }) {
        const res = await apiFetch<LoginResponse>('/auth/login', {
          method: 'POST',
          body: { email, password },
          skipAuthHandling: true
        })
        set({ user: res.user, token: res.token })
        return res
      },
      logout() {
        set({ user: null, token: null })
      },
      async refreshMe() {
        const res = await apiFetch<{ user: UserPublic }>('/auth/me')
        set({ user: res.user })
      },
      setHydrated() {
        set({ hydrated: true })
      }
    }),
    {
      name: 'tivy.auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ user: state.user, token: state.token }),
      onRehydrateStorage: () => (state) => {
        state?.setHydrated()
      }
    }
  )
)

export function selectUser(state: AuthState): UserPublic | null {
  return state.user
}

export function selectIsAuthenticated(state: AuthState): boolean {
  return state.token !== null && state.user !== null
}
